'use strict';

var defaultNewDate = require('../internal/defaultNewDate');

var DATE_OPTIONS = {
  'newDateInternal': defaultNewDate
};

module.exports = DATE_OPTIONS;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/date/var/DATE_OPTIONS.js
// module id = 288
// module chunks = 1